module.exports = __webpack_public_path__ + "img/internazionale.1e0bfed6.png";